export default __webpack_public_path__ + "static/media/calisma.60a2d5f2.jpg";